import { CommonStateStatus } from '@app/core/enums/common-state-status.enum';

export function getCommonStateStatusCssColor(qualityStatus: CommonStateStatus): `var(${string})` {
  return qualityStatus === CommonStateStatus.Critical
    ? 'var(--p-other-red-500)'
    : qualityStatus === CommonStateStatus.Warning
      ? 'var(--p-orange-500)'
      : 'var(--p-other-green-500)';
}
